angular.module('bbl.services.calls', [])
  .factory('Calls', ['Api', 'Toast', CallsServiceFactory]);

function CallsServiceFactory(Api, Toast) {
  var errorToast = Toast.error.bind(Toast, 'Something went wrong when performing this action. Please try again!');

  function lowerRaisedHand() {
    var onSuccess = function onLowerRaisedHand() {
      this.call.has_hand_raised = false;
    }.bind(this);

    Api.calls.lowerRaisedHand(this.call.sid).then(onSuccess, errorToast);
  }

  function toggleMute() {
      var toggle = !this.call.is_muted ? 'unmute' : 'mute';

      return Api.calls
        .toggleStatus(toggle, this.bridge, this.call.sid)
        .catch(errorToast);
  }

  function toggleDeaf() {
      var toggle = !this.call.is_deafened ? 'undeaf' : 'deaf';

      return Api.calls
        .toggleStatus(toggle, this.bridge, this.call.sid)
        .catch(errorToast);
  }

  function boot() {
    return Api.calls.boot(this.bridge, this.call.sid)
      .catch(errorToast);
  }

  function nudge() {
    return Api.calls.nudge(this.bridge.id+'/', this.call.sid)
      .catch(errorToast);
  }

  function lock() {
    var showToast = function onConferenceLock() {
      Toast.notify('The conference is <strong>{{status}}</strong>.', {data: {
        status: this.bridge.locked ? 'locked' : 'unlocked'
      }});
    };

    return Api.calls.lock(this.call.conference, null, {cache: false})
      .then(showToast.bind(this))
      .catch(errorToast);
  }

  return function CallModel(call, bridge) {
    var _this = {call: call, bridge: bridge};

    return angular.extend(call, {
      lowerRaisedHand: lowerRaisedHand.bind(_this),
      toggleMute: toggleMute.bind(_this),
      toggleDeaf: toggleDeaf.bind(_this),
      boot: boot.bind(_this),
      nudge: nudge.bind(_this),
      lock: lock.bind(_this),
    });
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/calls-service.js
 ** module id = 153
 ** module chunks = 0
 **/